import React from 'react';

import classNames from 'classnames/bind';
import style from './Grid.scss';
const ctx = classNames.bind(style);

const Grid = props => (
  <div className={ctx('grid')}>
    <ul>
      {props.blocks.map((block, idx) => (
        <li
          key={idx}
          style={{
            display: 'inline-block',
            verticalAlign: 'top',
            width: (block.width / props.fullWidth) * 100 + '%',
          }}
        >
          {block.content}
        </li>
      ))}
    </ul>
  </div>
);

export default Grid;
